// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box{
    width: 70%;
    padding: 20px;       
    border: 1px solid #ccc;
    background-color: red;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    cursor: move;
}


#cancel-location-delete, #confirm-location-delete{
    padding: 10px 20px;
    background-color: rgb(255, 255, 255);
    color:black;
    border: none;
    border-radius: 1em;
    margin: 0.25em;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease, colour 0.3s ease;
}


#cancel-location-delete:hover, #confirm-location-delete:hover{
    font-weight:bold;
}
`, "",{"version":3,"sources":["webpack://./src/css/deleteWarning.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,0CAA0C;IAC1C,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,eAAe;IACf,wDAAwD;AAC5D;;;AAGA;IACI,gBAAgB;AACpB","sourcesContent":[".box{\n    width: 70%;\n    padding: 20px;       \n    border: 1px solid #ccc;\n    background-color: red;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    cursor: move;\n}\n\n\n#cancel-location-delete, #confirm-location-delete{\n    padding: 10px 20px;\n    background-color: rgb(255, 255, 255);\n    color:black;\n    border: none;\n    border-radius: 1em;\n    margin: 0.25em;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, colour 0.3s ease;\n}\n\n\n#cancel-location-delete:hover, #confirm-location-delete:hover{\n    font-weight:bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
